import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { KeyValueDTO } from '@ms/core';
import { logRequest } from 'app/main/shared/http-utils';
import { Observable } from 'rxjs';
import { SalaryExperience } from '../positions/base-salary/salary-experience.model';

@Injectable({
    providedIn: 'root',
})
export class SalaryExperienceService {
    baseUrl = '/school-service/api/salary-experience';

    constructor(private http: HttpClient) {}

    getAllByPositionId(id: string): Observable<HttpResponse<SalaryExperience[]>> {
        return this.http.get<SalaryExperience[]>(`${this.baseUrl}/position/${id}`, { observe: 'response' });
    }
    getAllWithKeyValueByPositionId(id: string): Observable<HttpResponse<KeyValueDTO[]>> {
        return this.http.get<KeyValueDTO[]>(`${this.baseUrl}/key-value/position/${id}`, { observe: 'response' });
    }
    create(baseSalary: SalaryExperience): Observable<HttpResponse<SalaryExperience>> {
        return this.http.post<SalaryExperience>(this.baseUrl, baseSalary, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    update(baseSalary: SalaryExperience): Observable<HttpResponse<SalaryExperience>> {
        return this.http.put<SalaryExperience>(this.baseUrl, baseSalary, {
            observe: 'response',
            headers: logRequest(),
        });
    }

    delete(id: string): Observable<HttpResponse<any>> {
        return this.http.delete<any>(`${this.baseUrl}/${id}`, { observe: 'response', headers: logRequest() });
    }
}
